module.exports = __webpack_public_path__ + "static/img/logo.c0b39aa6.png";